
























































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { CardForm } from '@/components/bwaff';
import Form, { Send } from '@/components/form-base';
import {pick, omit} from 'lodash';
import { GeneralApi } from '../api';
import dialogTargetMock from '@/components/dialogs/dialog-target-mock';
import { loadLanguageAsync } from '@/i18n';
import currencyList from '@/components/helpers/currency-list';
import UiSelectLanguage from '@/components/ui/ui-select-language.vue';
import UserApi from '@/services/rest/bemob/user';


@Component({
  components: {
    UiSelectLanguage,
    CardForm
  }
})
export default class Login extends Form {
  @Prop() 
  api: GeneralApi;
  userApi: UserApi = new UserApi();

  error: boolean = false;
  error_message: string = '';
  edit: boolean = false;
  show_password: boolean = false;
  dialogTargetMock = dialogTargetMock();

  form: any = {};

  get formPick() {
    return [
      'lastName',
      'firstName',
      'email',
      'currencyId',
      'language'
    ];
  }
  
  @Watch('$store.state.user')
  dataReceived(val: any) {
    this.fillForm(val);
  }

  mounted() {
    this.fillForm(this.$store.state.user);
  }

  fillForm(source: any) {
    this.form = {
      ...this.form,
      ...pick(source, this.formPick)
    };
  }

  get currencySymbol() {
    return this.form.currencyId ? currencyList[this.form.currencyId] : '';
  }

  cancel() {
    this.fillForm(this.$store.state.user);
    this.edit = false;
    this.state = {};
  }

  @Send()
  submit() {
    const { language, firstName, lastName } = this.form

    return this.userApi.patchUser({ language, firstName, lastName })
      .then((res: any) => {
        this.$store.commit('updateUser', res);
        this.edit = false;
        this.bus.emit('toast-success', this.t('Changes have been successfully saved'));

        loadLanguageAsync(language);
      });
  }
  changeLanguage(data:string) {
    this.form.language = data;
  }
}
